module.exports = require('./lib/linkify-element').default;



//////////////////
// WEBPACK FOOTER
// ./~/linkifyjs/element.js
// module id = 423
// module chunks = 1